import styled from '@emotion/styled';
import { Typography } from '@material-ui/core';
import { ClassAttributes, createElement, Fragment } from 'react';
import { FormattedMessage } from 'react-intl';

import {
  DynamicSchemaDefinitionFixed,
  DynamicSchemaDefinitionMultiLineText,
  DynamicSchemaDefinitionPositiveInteger,
  DynamicSchemaDefinitionSingleLineText,
} from '../../../../../graphql/generated/graphql';
import LfToBr from '../../../primitive/LfToBr';
import Linkify from '../../../primitive/Linkify';
import _RouterLink from '../../../primitive/RouterLink';
import Base from './Base';

interface Props {
  field:
    | Pick<DynamicSchemaDefinitionSingleLineText, 'label'>
    | Pick<DynamicSchemaDefinitionMultiLineText, 'label'>
    | Pick<DynamicSchemaDefinitionPositiveInteger, 'label'>
    | Pick<DynamicSchemaDefinitionFixed, 'label'>;
  value: string | number | null;
  latestValue: string | number | null;
  beforeValue: string | number | null;
  className?: string;
}

const AsPlainText = ({ field, latestValue, beforeValue, className }: Props & ClassAttributes<HTMLElement>) => {
  return (
    <Base field={field} className={className}>
      {latestValue === beforeValue ? (
        !latestValue ? (
          <Value>
            <FormattedMessage id={'creative_brief_detail.field.empty'} />
          </Value>
        ) : (
          <Value>
            <LfToBr text={`${latestValue}`}>
              {(line, key) => (
                <Linkify text={line} key={key}>
                  {(url, key) => (
                    <RouterLink href={url} withNewTab key={key}>
                      {url}
                    </RouterLink>
                  )}
                </Linkify>
              )}
            </LfToBr>
          </Value>
        )
      ) : (
        <Fragment>
          <BeforeValue>
            <LfToBr text={`${beforeValue ? beforeValue : '　'}`}>
              {(line, key) => (
                <Linkify text={line} key={key}>
                  {(url, key) => (
                    <RouterLink href={url} withNewTab key={key}>
                      {url}
                    </RouterLink>
                  )}
                </Linkify>
              )}
            </LfToBr>
          </BeforeValue>
          <AfterValue>
            <LfToBr text={`${latestValue ? latestValue : '　'}`}>
              {(line, key) => (
                <Linkify text={line} key={key}>
                  {(url, key) => (
                    <RouterLink href={url} withNewTab key={key}>
                      {url}
                    </RouterLink>
                  )}
                </Linkify>
              )}
            </LfToBr>
          </AfterValue>
        </Fragment>
      )}
    </Base>
  );
};

const Value = styled(Typography)({
  wordBreak: 'break-word' as any,
  hyphens: 'auto',
});

const BeforeValue = styled(Typography)({
  padding: '4px',
  wordBreak: 'break-word' as any,
  hyphens: 'auto',
  background: '#fdd7d5',
  marginBottom: '8px',
});

const AfterValue = styled(Typography)({
  padding: '4px',
  wordBreak: 'break-word' as any,
  hyphens: 'auto',
  background: '#c8ffd8',
});

const RouterLink = styled(_RouterLink)({ display: 'inline' });

export default AsPlainText;
